import store from '@/store'
import lib from '@/library'

export default {

  data () {
    return {
    }
  },

  computed: {
    bodyClass () {
      var classStrings = [
        this.urlClasses,
        this.userAgentClasses,
        this.prismClasses,
        this.cduStateClasses
      ]

      return classStrings.join(' ')
    },

    cduStateClasses () {
      return 'cdu-state-' + store.getters['cduState/getScreenState']
    },

    urlClasses () {
      return 'url-state-name-' + this.$route.name + ' ' + lib.core.url.convertUrlToClasses(this.$route.path)
    },

    userAgentClasses () {
      return [
        'browser-'.concat(lib.core.userAgent.browser.name),
        'browser-version-'.concat(lib.core.userAgent.browser.version),
        'os-'.concat(lib.core.userAgent.os.name),
        'os-version-'.concat(lib.core.userAgent.os.version)
      ].join(' ')
    },

    prismClasses () {
      var prismOptions = {
        is2displaymarketingdata: 'prism-marketing-data',
        is2displayupcomingevents: 'prism-upcoming-events',
        is2showsingleevent: 'prism-single-event',
        is2showeventsin2columns: 'prism-two-columns',
        is2showoutrightevents: 'prism-outright',
        halftemplate: 'prism-half-template'
      }

      var result = ''

      for (var option in this.screenConfiguration) {
        if (this.screenConfiguration.hasOwnProperty(option) && this.screenConfiguration[option]) {
          if (prismOptions[option]) {
            result = result.concat(prismOptions[option] + ' ')
          }
        }
      }

      if (lib.cdu.config.isHalfTemplate()) {
        result = result.concat(prismOptions.halftemplate)
      }

      return result.trim()
    },

    screenConfiguration () {
      return store.getters['cduState/getScreenConfiguration']
    }
  },

  methods: {
    attachTemplateClassToHtmlElement () {
      var htmlElement = document.documentElement
      var templateClasses = [
        'url-small',
        'url-standard',
        'url-big'
      ]

      for (var i = 0; i < templateClasses.length; i++) {
        if (this.bodyClass.indexOf(templateClasses[i]) > -1) {
          htmlElement.className = templateClasses[i].replace('url-', '')
          break
        }
      }
    }
  },

  mounted () {
    this.attachTemplateClassToHtmlElement()
  },

  watch: {
    '$route' (to) {
      this.attachTemplateClassToHtmlElement()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/CssClasses.js